import { render, staticRenderFns } from "./DeprecationDetailOverlay.vue?vue&type=template&id=ff7b3ad2"
import script from "./DeprecationDetailOverlay.vue?vue&type=script&lang=js"
export * from "./DeprecationDetailOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports